'use client';

import React, { createContext, useState, useContext, useEffect,useCallback,useRef } from 'react';
import { jwtDecode } from 'jwt-decode';
import CryptoJS from 'crypto-js';
import io from 'socket.io-client';  

import { getEncryptLocalStorage, setLocalStorage, removeLocalStorage, getLocalStorage } from '@/lib/localStorage';
import { message } from 'antd';

const GlobalContext = createContext();

export const useGlobalContext = () => useContext(GlobalContext);

export const GlobalContextProvider = ({ children }) => {
    
    
    const [theme, setTheme] = useState('light_theme');
    const [DataUser,setDataUser] = useState()
    const [socket,setSocket] = useState(null)
    const API = process.env.NEXT_PUBLIC_DEV ==='true' ? process.env.NEXT_PUBLIC_API_DOMAINDEV : process.env.NEXT_PUBLIC_API_DOMAIN
    const base_url_img =process.env.NEXT_PUBLIC_ServerIMG
    const eve_ebook =process.env.NEXT_PUBLIC_URL
    const privateKey = process.env.NEXT_PUBLIC_PRIVATEKEY;
    const FACEBOOK_CLIENT_ID = process.env.NEXT_PUBLIC_FACEBOOK_CLIENT_ID
    const GOOGLE_CLIENT_ID = process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID
    const APP_LIFF_ID = process.env.NEXT_PUBLIC_LIFF_ID
    const API_Admin = process.env.NEXT_PUBLIC_API_ADMIN
    const hasRun = useRef(false);

    const [Token,setToken] = useState(getLocalStorage('Token'))
    const [CartAction, setCartAction] = useState(getEncryptLocalStorage('Cart'));
    const [isLogin,setLogin] = useState(false)
    const [isLoginModal ,setIsLoginModal] = useState(false)
    const [modalPayment,setModalPayment] = useState(false)
    const [typeLogin,setTypeLogin] = useState('login')

    const [configData,setConfigData] = useState(getEncryptLocalStorage('Config'))
    const [ref,setRefID] = useState()
    const [isUserReady, setIsUserReady] = useState(false);

    const [ dataPayment,setDataPayment ] = useState([])
    const [StepPayment,setStepPayment] = useState('')
    const [messagePaymenmt,setMessagePayment] = useState('')

    const [screen,setScreen] = useState('')
    const [socketNoti,setSocketNoti] = useState(null)
    const [ loadingPayment,setLoadingPayment ] = useState(false)
    const [Noti_length,setNoti] = useState(0)

    const parseShalveData = (val) => {
        if (!val) return [];
        let data = val;
        if (typeof data === 'string') {
            try { data = JSON.parse(data); } catch { return []; }
        }
        if (typeof data === 'string') {
            try { data = JSON.parse(data); } catch { return []; }
        }
        return Array.isArray(data) ? data : [];
    };

    const [DataShalve, setDataShalve] = useState(() => parseShalveData(getLocalStorage('Shalve')));

    const [headers,setHeaders] = useState({
        "Content-Type": 'application/json',
        // "X-Client-Domain": 'https://eveebook.com',
    })


    useEffect(() => {
        if (typeof window !== 'undefined') {
            const updateScreen = () => {
                const width = window.innerWidth;
                
                if (width > 1440) {
                    setScreen('desktop');
                } else if (width > 744) {
                    setScreen('tablet');
                } else {
                    setScreen('mobile');
                }
            };
        
            updateScreen(); 
            window.addEventListener('resize', updateScreen); 

        
            return () => window.removeEventListener('resize', updateScreen); 
        }
    }, []);
    

    const refreshCart = () => {
        const localCart = getEncryptLocalStorage('Cart');
        setCartAction(localCart);
    };

    const refreshShalve = () => {
        const localCart = getLocalStorage('Shalve');
        setDataShalve(parseShalveData(localCart));
    }


    useEffect(() => {
        const savedTheme = localStorage.getItem('theme');
        const Noti = localStorage.getItem('Noti')
        if (savedTheme) {
            if(savedTheme!=='light_theme' && savedTheme!=='dark_theme'){
                // console.log(123);
                setTheme('light_theme')
            }else{
            setTheme(savedTheme);

            }
        }
        if(Noti){
            setNoti(Noti)
        }
    }, []);

    useEffect(() => {
        localStorage.setItem('theme', theme);
    }, [theme]);

    const checkToken = useCallback(async () => {
        const token = localStorage.getItem('Token'); 
        
        if (token) { 
            try {
                const decoded = await jwtDecode(token); 
                // ตรวจสอบว่าโทเค็นหมดอายุแล้วหรือไม่
                if (decoded?.exp && decoded.exp * 1000 < Date.now()) {
                    console.warn('โทเค็นหมดอายุ กรุณาเข้าสู่ระบบใหม่');
                    message.warning('โทเคนหมดอายุ กรุณาเข้าสู่ระบบใหม่');
                    localStorage.removeItem('Token');
                    setToken(null);
                    setDataUser(null);
                    setLogin(false);
                    setTypeLogin('login');
                    setIsLoginModal(true);
                    return false;
                }
                setToken(token);
                setDataUser(decoded);
                setIsUserReady(true);
                const updatedHeaders = { 
                    "Content-Type": 'application/json',
                    "Authorization": `${token}`,
                    // "X-Client-Domain": 'https://eveebook.com',
                };
                setHeaders(updatedHeaders);
                setLogin(true);
            } catch (error) {
                localStorage.removeItem('Token');
                setToken(null);
                setDataUser(null);
                setLogin(false);
            }
        } else {
            setToken(null);
            setDataUser(null);
            setLogin(false);
        }
        return true;
        
    }, []);

    useEffect(() => {
        const handleAuthExpired = (e) => {
            const msg = e?.detail?.message || 'โทเคนหมดอายุ กรุณาเข้าสู่ระบบใหม่';
            console.warn('ได้รับแจ้งเตือนโทเค็นหมดอายุ -> ให้เข้าสู่ระบบใหม่');
            message.warning(msg);
            localStorage.removeItem('Token');
            setToken(null);
            setDataUser(null);
            setLogin(false);
            setTypeLogin('login');
            setIsLoginModal(true);
        };

        window.addEventListener('auth:expired', handleAuthExpired);
        return () => window.removeEventListener('auth:expired', handleAuthExpired);
    }, []);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            if (hasRun.current) return;
            hasRun.current = true;

            checkToken();
        }
    }, [checkToken]);



    useEffect(() => {
        if (!Token  || typeof window === 'undefined') return;


        const SetSocket = io(API, {
            transports: ['websocket', 'polling'],
        });

        const SocketNoti = io(API_Admin,{
            transports:['websocket','polling'],

        })

        setSocket(SetSocket);
        setSocketNoti(SocketNoti)

        return () => SetSocket.disconnect();
    }, [API, Token]);

    useEffect(() => {
        if(typeof window !== 'undefined' && socket && DataUser && DataUser.user_id && socketNoti && isUserReady){

            const user_id = DataUser.user_id;

            socket.on(user_id, (data) => {
                
                console.log('มีการอัพเดตโทเคน');
                // console.log(data);

                if (data.TokensUser) {
                    localStorage.setItem("Token", data.TokensUser);
                }
            });
            socket.on(ref, (data) => {
                console.log("📦 ได้รับ payment_success");
                if (data.refID === ref) {
                    removeLocalStorage("Cart");
                    refreshCart();
                    removeLocalStorage('Shalve')
                    setLocalStorage('Shalve', parseShalveData(data.user_shalve))
                    refreshShalve()
                    setMessagePayment("✅ ชำระเงินสำเร็จ");
                    setStepPayment("success");
                }
            });

            socketNoti.on(`noti_user:${DataUser.uid}`,(data)=>{
                const noti = Number(localStorage.getItem('Noti')) + 1
                localStorage.setItem('Noti',noti)
                setNoti(noti)
                // console.log(data);
                
            })

            socket.on(user_id, (data) => {
                
                console.log('มีการอัพเดตโทเคน');
                // console.log(data);

                if (data.TokensUser) {
                    localStorage.setItem("Token", data.TokensUser);
                }
            });



            return () => {
                socket.off(user_id);
                socket.off(ref);
            };
        }
       
    }, [socket, isUserReady,DataUser,ref]);

    

    

    return (
        <GlobalContext.Provider value={{ 
            theme, setTheme,DataUser,setDataUser,
            API,headers,privateKey,FACEBOOK_CLIENT_ID,GOOGLE_CLIENT_ID,APP_LIFF_ID,
            eve_ebook,base_url_img,
            Token,setToken,socket,DataShalve,setDataShalve,
            screen,refreshCart,CartAction,ref,setRefID,
            isLogin,setLogin,isLoginModal ,setIsLoginModal,typeLogin,setTypeLogin,
            modalPayment,setModalPayment,dataPayment,setDataPayment,StepPayment,setStepPayment,
            messagePaymenmt,setMessagePayment  , checkToken,Noti_length,setNoti }}>
            {children}
        </GlobalContext.Provider>
    );
}
